import React, { useState } from "react";
import { X } from "lucide-react";
import { LOGO } from "@/lib/ellaApi";
import ApkDownloadButton from "@/components/ApkDownloadButton";

const DISMISS_KEY = "ella_play_banner_dismissed";

/** Dismissible "get the Android app" strip shown on the home page. */
export default function PlayStoreBanner() {
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");
  if (hidden) return null;

  return (
    <div className="mx-4 mt-3 flex items-center gap-3 rounded-2xl border border-gray-100 bg-white p-3 shadow-sm" data-testid="play-store-banner">
      <div className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center shrink-0">
        <img src={LOGO} alt="" className="w-7 h-7 object-contain" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-bold text-gray-900 leading-tight">Ella Froze di Android</p>
        <p className="text-[11px] text-gray-500 leading-tight mt-0.5">Belanja lebih praktis — unduh di Google Play</p>
      </div>
      <ApkDownloadButton className="shrink-0 min-w-[104px] rounded-full bg-gray-900 text-white text-[11px] font-semibold px-3 py-2 hover:bg-black" />
      <button
        onClick={() => { localStorage.setItem(DISMISS_KEY, "1"); setHidden(true); }}
        className="shrink-0 p-1 text-gray-300 hover:text-gray-500"
        aria-label="Tutup"
        data-testid="play-store-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
